<template>
	<vx-card title="Moneybird instellingen">
		<template slot="actions">
			<vx-tooltip class="flex" text="Hoe en wat?">
				<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
			</vx-tooltip>
		</template>
		<div>
			<div v-if="moneybirdError === true">
				<vs-alert title="Toegang geweigerd" color="danger">
					Je hebt de toegang voor de moneybird koppeling geweigerd.
				</vs-alert>
				<br />
			</div>
			<div>
				<div v-if="loading">
				</div>
				<div v-else>
					<div v-if="moneybird">
						<div class="w-full vx-row">
							<div class="vx-col w-full">
								<h4>Client id:</h4>
							</div>
							<div class="vx-col w-full">
								<label class="input-label">{{ moneybird.client_id }}</label><br /><br />
							</div>
							<div class="vx-col w-full">
								<h4>Client secret:</h4>
							</div>
							<div class="vx-col w-full">
								<label class="input-label">{{ moneybird.client_secret }}</label><br /><br />
							</div>
							<div class="vx-col w-full">
								<h4>Administratie:&ensp; </h4>
							</div>
							<div class="vx-col w-full">
								<label class="input-label">{{ moneybird.administration_name }}&ensp;</label><br /><br />
							</div>
							<div class="vx-col w-full">
								<h4>Factuur sjabloon:&ensp; </h4>
							</div>
							<div class="vx-col w-full">
								<vue-multiselect
									style="width: 350px"
									placeholder="Selecteer factuur sjabloon"
									v-model="documentStyle.selected"
									:options="documentStyle.options"
									:show-labels="false"
									:allow-empty="false"
									track-by="id"
									label="name" />
								<br>
							</div>
							<div class="vx-col w-full">
								<h4>Automatisch facturen aanmaken bij een bestelling:</h4>
							</div>
							<div class="vx-col w-full mb-5">
								<vs-checkbox name="autoInvoice" v-model="autoMakeInvoice" />
							</div>
							<div class="vx-col w-full">
								<vs-button class="combobox" @click.native="updateMoneybird()" color="primary"
										   type="filled">Opslaan
								</vs-button>
							</div>
						</div>
					</div>
					<div v-else-if="!moneybird">
						<div class="w-full vx-row">
							<div class="vx-col w-full">
								<label>
									Als je Moneybird koppelt met piqwise kun je gemakkelijk je bestellingen
									Factureren, inboeken ect.
									Om Moneybrid te koppelen moet je een client id en client secret opvragen, dit doe je
									door
									<u><a href="https://moneybird.com/user/applications/new"
										  target="_blank">hier</a></u> je naam en "Callback url" in
									te vullen voor de "Api token voor externe applicatie".
								</label>
							</div>
							<div class="vx-col w-full">
								<label>Als je dit hebt gedaan krijg je je client secret en client id te zien, deze moet
									je in
									piqwise invullen om met moneybird te koppelen.
								</label>
							</div>
							<div class="vx-col w-full">
								<label class="lbl-authUrl">Callback url: {{
										this.urlAuth.urlAuth.authUrl.slice(0, 30)
									}}... </label>
								<vs-button
									type="flat"
									v-clipboard:copy="copyUrl"
									v-clipboard:success="onCopy"
									v-clipboard:error="onError">
									<font-awesome-icon :icon="'copy'" />
									Kopiëren
								</vs-button>
							</div>
							<div class="vx-col w-full">
								<h4>Client id*</h4>
							</div>
							<div class="vx-col w-full">
								<vs-input v-validate="'required|max:100'" name="clientId"
										  class="lg:w-2/5 md:w-2/5 w-full" placeholder="Je client id"
										  v-model="moneybirdCredentials.client_id" />
								<span class="text-danger text-sm"
									  v-show="errors.has('clientId')">{{ errors.first('clientId') }}</span>&emsp;
							</div>
							<div class="vx-col w-full">
								<h4>Client secret*</h4>
							</div>
							<div class="vx-col w-full">
								<vs-input v-validate="'required|max:100'" name="clientSecret"
										  class="lg:w-2/5 md:w-2/5 w-full"
										  placeholder="Je client secret"
										  v-model="moneybirdCredentials.client_secret" />
								<span class="text-danger text-sm"
									  v-show="errors.has('clientSecret')">{{ errors.first('clientSecret') }}</span>&emsp;
							</div>
							<div class="vx-col w-full">
								<vs-button class="lg:w-2/5 md:w-2/5 w-full" @click.native="createMoneybird"
										   color="primary" type="filled">opslaan
								</vs-button>
								<label id="lbl-verzenden"><br />
									Wanneer je op "opslaan" klikt ga je akkoord met de maandelijkse kosten van 12,95
									voor gebruik van de moneybird
									koppeling.
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapGetters} from 'vuex';
import vSelect from 'vue-select';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';
import VueClipboard from 'vue-clipboard2';

Vue.use(VeeValidate);
Vue.use(VueClipboard);

const dict = {
	custom: {
		clientId: {
			required: 'Vul hier je id in',
			max: 'Je kunt maximaal 100 karakters invullen',
		},
		clientSecret: {
			required: 'Vul hier je secret in',
			max: 'Je kunt maximaal 100 karakters invullen',
		},
	}
};
Validator.localize('en', dict);

export default {
	name: 'module-accounting-moneybird',
	data() {
		return {
			moneybirdError: false,
			loading: true,
			moneybirdCredentials: {
				client_id: '',
				client_secret: '',
				administration_id: '',
				administration_name: '',
			},
			documentStyle: {
				options: [],
				selected: null,
				selectedId: null,
			},
			autoMakeInvoice: null,
			sendDocumentStyles: {},
		}
	},
	mounted() {
		this.openLoading();
		this.checkAccess();
	},
	computed: {
		...mapGetters({
			moneybird: 'moneybird/moneybird',
		}),
	},
	methods: {
		...mapActions({
			documentStyles: 'moneybird/documentsStylesMoneybird',
			authUrl: 'moneybird/authUrlMoneybird',
		}),
		openLoading() {
			this.$vs.loading();
		},
		init() {
			this.authUrlMoneybird();
			this.$store.dispatch('moneybird/init').then(res => {
				if (this.moneybird) {
					this.documentStyle.selectedId = this.$store.state.moneybird.moneybird.document_style;
					this.autoMakeInvoice = this.$store.state.moneybird.moneybird.auto_make_invoice;
				}
				this.fillSelectDocumentStyles().then(() => {
					this.closeLoading();
				});
			}).catch(error => {
				this.closeLoading();
			});
		},
		closeLoading() {
			this.$vs.loading.close();
			this.loading = false;
		},
		checkAccess() {
			if (this.$route.fullPath === '/settings/moneybird?access_denied=true') {
				this.moneybirdError = true;

				this.init();
			} else if (this.$route.fullPath === '/settings/moneybird?connected=true') {
				this.$store.dispatch('moneybird/validateMoneybird').then(res => {
					this.$vs.notify({
						color: 'success',
						title: 'Gelukt!',
						text: 'Je moneybird is account is gekoppelt.',
					});

					this.init();
				}).catch(err => {
					this.$vs.notify({
						color: 'danger',
						title: 'Oops!',
						text: 'De ingevulde data lijkt ongeldig.',
					});

					this.init();
				});
			} else {
				this.init();
			}
		},
		fillSelectDocumentStyles() {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('moneybird/documentsStylesMoneybird').then(res => {
					this.documentStyle.options = [...this.$store.state.moneybird.documentStyles];
					for (let i = 0; i < this.documentStyle.options.length; i++) {
						if (this.documentStyle.selectedId === this.documentStyle.options[i].id) {
							this.documentStyle.selected = this.documentStyle.options[i];
						}
					}
					resolve();
				}).catch(err => {
					this.$vs.notify();
					reject();
				});
			});
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.moneybird)
		},
		createMoneybird() {
			this.$validator.validateAll().then(result => {
				if (!result) {
					this.$vs.notify({
						color: 'danger',
						title: 'Gegevens zijn niet opgeslagen',
						text: 'Vul alle velden in',
					})
				} else {
					this.$store.dispatch('moneybird/createMoneybird', this.moneybirdCredentials).then(res => {
						location.replace(this.moneybird.auth_url);
					}).catch(err => {
					})
				}
			})
		},
		authUrlMoneybird() {
			this.$store.dispatch('moneybird/authUrlMoneybird').then(res => {
				this.urlAuth = this.$store.state.moneybird;
				this.copyUrl = this.$store.state.moneybird.urlAuth.authUrl;
			}).catch(err => {
				this.$vs.notify();
			});
		},
		updateMoneybird() {
			const params = {
				'document_style': this.documentStyle.selected.id,
				'auto_make_invoice': this.autoMakeInvoice
			}
			this.$store.dispatch('moneybird/updateMoneybird', params).then(res => {
				this.createNotifySucces();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		createNotifySucces() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'Je gegevens zijn opgeslagen.',
			})
		},
		createNotifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Oops',
				text: 'Er ging iets fout.',
			})
		},
		onCopy() {
			this.$vs.notify({
				title: 'Gelukt!',
				text: 'De callback url is gekopieerd',
				color: 'success',
				iconPack: 'feather',
				icon: 'icon-check-circle'
			})
		},
		onError() {
			this.$vs.notify({
				title: 'Oops',
				text: 'Er is iets fout gegaan tijdens het kopieren',
				color: 'danger',
				iconPack: 'feather',
				icon: 'icon-alert-circle'
			})
		},
	}
}
</script>

<style scoped>
#lbl-verzenden {
	font-size: 10px;
}

.combobox {
	width: 30vh;
}

.lbl-authUrl {
	overflow-wrap: break-word;
}
</style>
